import React from "react";
import DMModuleSubtopic from "../DMModuleSubtopic";

const BasicsTerminologiesTreesModule = () => (
  <DMModuleSubtopic
    title="Basics and Terminologies of Trees"
    videos={[
      "https://www.youtube.com/embed/99CeQT1X_KU",
      "https://www.youtube.com/embed/a5CC4uzbJVg",
      "https://www.youtube.com/embed/Fv_6FM9Bw_U",
      "https://www.youtube.com/embed/kaDHTyaon38"
    ]}
    takeaways={[]}
    questions={[
        {image:"/dm_48.png"},
        {image:"/dm_49.png"},
        {image:"/dm_50.png"},
        {image:"/dm_51.png"},
        {image:"/dm_52.png"},
        
    ]}
    exampleVideos={[]}
  />
);

export default BasicsTerminologiesTreesModule;
